module.exports = __webpack_public_path__ + "media/Rathaustreppen.93984a42.mp4";